import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPassword } from '@app/models';
import { getDeepFromObject } from '@nebular/auth';

import { AccountService, Toaster } from '@app/services';

@Component({
  selector: 'ngx-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: [
    '../../layout/auth.style.scss',
  ],
})

export class ForgotPasswordComponent {
  redirectDelay: number = 0;
  showMessages: any = {};
  provider: string = '';
  errors: string[] = [];
  messages: string[] = [];
  user: ForgotPassword = new ForgotPassword();
  submitted: boolean = false;
  config = {};

  constructor(
    private $account: AccountService,
    protected router: Router,
    private toaster: Toaster,
  ) {
    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.provider = this.getConfigValue('forms.login.provider');
  }

  async requestToken() {
    this.errors = [];
    this.submitted = true;
    try {
      await this.$account.requestToken(this.user.username);
      this.user.username = ""
      const message = `Thank you, if that email exists in our system you will receive an email with instructions on how to reset the password.`;
      this.toaster.show('success', 'Email Sent', message);

    } catch (err) {
      const errMessage = err && err.error ? err.error.detail : 'Something went wrong, please try again later';
      this.toaster.show('error', 'Error', errMessage);
      if (err.status === 400) this.errors.push(err.error.detail);
      console.error(err);
    }

    this.submitted = false;
  }


    getConfigValue(key: string): any {
        return getDeepFromObject(this.config, key, null);
    }
}
